import React from 'react';
import { Button } from './Button';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gray-900 pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-211">
      {/* Background styling elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-212">
        <div className="absolute -top-1/2 -right-1/4 w-[1000px] h-[1000px] rounded-full bg-blue-600/20 blur-3xl mix-blend-screen" data-id="element-213"></div>
        <div className="absolute -bottom-1/2 -left-1/4 w-[800px] h-[800px] rounded-full bg-red-600/20 blur-3xl mix-blend-screen" data-id="element-214"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-30" data-id="element-215"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center" data-id="element-216">
        <div className="w-full lg:w-3/5 text-center lg:text-left z-10" data-id="element-217">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/30 text-blue-400 text-sm font-bold uppercase tracking-wider mb-6" data-id="element-218">
            <span className="flex h-2 w-2 rounded-full bg-blue-500 animate-pulse" data-id="element-219"></span>
            New Release
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black text-white tracking-tight mb-6 leading-tight" data-id="element-220">
            INTRODUCING <br data-id="element-221" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600" data-id="element-222">
              GEN 3 DAEDO
            </span>{' '}
            <br data-id="element-223" />
            SCORING GEAR
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 mb-10 max-w-2xl mx-auto lg:mx-0 font-medium" data-id="element-224">
            The latest generation of electronic scoring equipment trusted by
            elite athletes, schools, and tournaments worldwide. Faster, more
            accurate, and built for champions.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-225">
            <a href="#gen3" className="w-full sm:w-auto" data-id="element-226">
              <Button variant="primary" className="w-full sm:w-auto text-lg px-8 py-4 group" data-id="element-227">
                Shop Gen 3
                <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-228" />
              </Button>
            </a>
            <a href="https://gen3quote.websiteforge.net/" target="_blank" rel="noopener noreferrer" data-id="element-229">
              <Button variant="outline" className="w-full sm:w-auto text-lg px-8 py-4" data-id="element-230">
                Request a Quote
              </Button>
            </a>
          </div>

          <div className="mt-10 flex items-center justify-center lg:justify-start gap-6 text-sm font-semibold text-gray-400" data-id="element-231">
            <div className="flex items-center gap-2" data-id="element-232">
              <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center" data-id="element-233">
                ✓
              </div>
              <span data-id="element-234">WT Approved</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-235">
              <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center" data-id="element-236">
                ✓
              </div>
              <span data-id="element-237">Official Distributor</span>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-2/5 mt-16 lg:mt-0 relative z-10" data-id="element-238">
          <div className="relative w-full max-w-md mx-auto aspect-[4/5] rounded-2xl shadow-2xl overflow-hidden" data-id="element-239">
            <img src="https://cdn.magicpatterns.com/uploads/kFf4sabSMZKByJBfAz5xtM/gen3quotelego.png" alt="Instant Gen 3 Quote - Daedo Lego Figure" className="w-full h-full object-cover object-top" data-id="element-240" />
          </div>
        </div>
      </div>
    </section>;
}